import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import { setActiveModal, toggleAnalyticsStrikethrough } from '../../ducks/calendarActions';

const IconButtonsWrapper = styled('div')`
  display: flex;
  gap: 10px;
  align-items: center;
`;

const IconWrapperStyle = styled('div')`
  cursor: pointer;
  transition: all 250ms ease-in-out;
  :hover {
    opacity: 0.7;
  }
`;

const BorderedIconWrapper = styled(IconWrapperStyle)`
  border: 1px solid #EEEEEE;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 1px 3px 0px #3031331A;
`;

const AnalyticsIconContainer = styled('div')`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StrikeThrough = styled('div')`
  position: absolute;
  width: 100%;
  height: 3px;
  background-color: #9E9E9E;
  top: 50%;
  transform: translateY(-50%) rotate(45deg);
  transition: opacity 0.3s ease;
  opacity: ${(props) => (props.visible ? 1 : 0)};
`;

const GearIconButtons = () => {
  const dispatch = useDispatch();
  const programType = useSelector((state) => state.calendar.data.programType);
  const isAnalyticsDisabled = useSelector(
    (state) => state.calendar.ui.isAnalyticsDisabled,
  );

  // Generate unique ID for tooltip
  const analyticsTooltipId = 'analytics-tooltip';

  const handleOpenSettings = () => {
    dispatch(setActiveModal('settingsModal'));
  };

  const handleToggleAnalytics = () => {
    dispatch(toggleAnalyticsStrikethrough());
  };

  return (
    <IconButtonsWrapper>
      <BorderedIconWrapper
        onClick={handleToggleAnalytics}
        data-tooltip-id={analyticsTooltipId}
      >
        <AnalyticsIconContainer>
          <IcomoonReact
            iconSet={iconSet}
            size={20}
            icon='trending-up'
            color='#9E9E9E'
          />
          <StrikeThrough visible={isAnalyticsDisabled} />
        </AnalyticsIconContainer>
      </BorderedIconWrapper>
      {programType !== 'free-form-program' && (
      <BorderedIconWrapper onClick={handleOpenSettings}>
        <IcomoonReact
          iconSet={iconSet}
          size={20}
          icon='gear'
          color='#9E9E9E'
        />
      </BorderedIconWrapper>
      )}
      {/* ReactTooltip components */}
      <ReactTooltip
        id={analyticsTooltipId}
        place='left'
        content={isAnalyticsDisabled ? 'Show Stats Bar' : 'Hide Stats Bar'}
        style={{
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: 'white',
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
        }}
      />
    </IconButtonsWrapper>
  );
};

export default GearIconButtons;
